



















import { Component, Mixins } from 'vue-property-decorator'
import { Cow } from '@/interfaces/Cow'
import { Milk } from '../interfaces/Milk'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class BackupsView extends Mixins(DexieService, SnackbarService) {
  created() {
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Backups'
  }

  backupLeches() {
    this.$db.mils.toArray().then((milks: Milk[]) => {
      const milkCsv = []
      milkCsv.push('Id;Dia;Litros;Vacas;Precio\n')
      milks.forEach((milk: Milk) => {
        milkCsv.push(
          `${milk.id};${milk.day};${milk.liter};${milk.cows};${milk.price}\n`
        )
      })
      const blob = new Blob(milkCsv, { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const a: any = document.querySelector('#backup-milk-link')
      const name = `Leche-backup-${new Date().toJSON().slice(0, 16)}.csv`
      a.href = url
      a.download = name
      a.innerHTML = ''
      a.click()
      this.notify({
        type: 'success',
        text: `File ${name} successfully saved`
      })
    })
  }

  backupVacas() {
    this.$db.cows.toArray().then((cows: Cow[]) => {
      const cowCsv = []
      cowCsv.push(
        'Numero;Rassa;Color;Hierro;Fecha de pregnese;Fecha de nacimiento;Observation;Finca;Fertalidad;Revisado;Mother number;Female;Status;Additional Cols;Abortions;Revisions\n'
      )
      cows.forEach((cow: Cow) => {
        let motherNumber = ''
        if (cow.mother_id) {
          const mother = cows.find((c: Cow) => c.id === cow.mother_id)
          motherNumber = mother.number
        }

        // race
        const race = this.$store.state.account.races.find(
          (r: any) => r.id === cow.race_id
        )
          ? this.$store.state.account.races.find(
              (r: any) => r.id === cow.race_id
            ).name
          : ''

        // iron
        const iron = this.$store.state.account.irons.find(
          (i: any) => i.id === cow.iron_id
        )
          ? this.$store.state.account.irons.find(
              (i: any) => i.id === cow.iron_id
            ).name
          : ''

        // farm
        const farm = this.$store.state.account.farms.find(
          (f: any) => f.id === cow.farm_id
        ).name

        console.log(this.$store.state.account)
        console.log(cow.additional_cols)

        const additionalCols = JSON.stringify(
          cow.additional_cols.map((col: any) => {
            let value = null
            if (col.value) {
              value = col.value
            } else if (col.value_id) {
              const val = this.$store.state.account.add_col_options.find(
                (o: any) => o.id === col.value_id
              )
              if (val) {
                value = val.value
              }
            }
            return {
              name: col.col_def.name,
              type: col.col_def.type,
              value,
            }
          })
        )

        console.log(additionalCols)

        cowCsv.push(
          `="${this.replaceChars(cow.number)}";${this.replaceChars(
            race
          )};${this.replaceChars(cow.color)};${this.replaceChars(
            iron
          )};${this.replaceChars(cow.pregnancyDate)};${this.replaceChars(
            cow.birthDate
          )};${this.replaceChars(cow.observation)};${this.replaceChars(farm)};${
            cow.fertility
          };${cow.selected};${this.replaceChars(motherNumber)};${cow.female};${
            cow.status
          };${additionalCols};${JSON.stringify(cow.abortions)};${JSON.stringify(
            cow.revisions
          )}\n`
        )
      })
      const blob = new Blob(cowCsv, { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const a: any = document.querySelector('#backup-cows-link')
      const name = `Vaca-backup-${new Date().toJSON().slice(0, 16)}.csv`
      a.href = url
      a.download = name
      a.innerHTML = ''
      a.click()
      this.notify({
        type: 'success',
        text: `File ${name} successfully saved`
      })
    })
  }

  replaceChars(text: string) {
    if (text) {
      return text.replace(/;/g, ',')
    } else {
      return ''
    }
  }
}
